export const requiredFieldsError = 'Aggregator/Payer combination not found';

export const requiredFieldsListHeaders = [
  { header: 'fieldName', label: 'FIELD NAME' },
  { header: 'format', label: 'FORMAT' },
];
